<script>
	import { onMount } from 'svelte';
	import { slide, fade } from 'svelte/transition';

	let fadeActive = false;

	function switchFade() {
		setTimeout(() => {
			fadeActive = true;
		}, 2500);
	}

	onMount(switchFade);
</script>

<div class="preloader">
	{#if !fadeActive}
		<div class="top-preloader" transition:slide={{ duration: 1000 }} />
		<div class="bottom-preloader" transition:slide={{ duration: 1000 }} />
		<div class="logo-preloader" transition:fade>
			<img src="images/logo.svg" alt="logo" />
		</div>
		<div class="spinner-preloader" />
	{/if}
</div>

<style>
	.top-preloader,
	.bottom-preloader {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 50%;
		z-index: 1001;
		background: #000;
		transition: all 2s;
	}

	.bottom-preloader {
		top: auto;
		bottom: 0;
	}

	.logo-preloader {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		z-index: 1003;
		margin: 0 auto;
		transition: all 2s;
		animation: blink 2s ease-in infinite;
	}

	.spinner-preloader {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		z-index: 1002;
		width: 200px;
		height: 200px;
		background: transparent;
		border-radius: 100%;
		border: 3px solid transparent;
		transition: all 1s;
		animation: spin 3s ease-out infinite;
	}

	@keyframes blink {
		0% {
			opacity: 1;
		}
		25% {
			opacity: 0.75;
		}
		50% {
			opacity: 0.5;
		}
		75% {
			opacity: 0.75;
		}
		100% {
			opacity: 1;
		}
	}

	@keyframes spin {
		0% {
			border: 3px solid transparent;
		}
		25% {
			border-top: 3px solid rgba(52, 73, 94, 0.8);
			border-left: 3px solid transparent;
		}
		50% {
			border-left: 3px solid rgba(127, 140, 141, 0.8);
			border-bottom: 3px solid transparent;
		}
		75% {
			border-bottom: 3px solid rgba(52, 73, 94, 0.8);
			border-right: 3px solid transparent;
		}
		90% {
			border-right: 3px solid rgba(255, 255, 255, 0.4);
			border-top: 3px solid rgba(52, 73, 94, 0.2);
		}
	}
</style>
